import { ConsultarEventosConstants } from "./ConsultarEventosConstants";

export type ConsultarEventosFiltrosStorage = {
  busca: string;
  numeroAudiencia: string;
  codigoAno: string;
  codigoSituacao: string;
  codigoTipoEvento: string;
  ordering: string;
  recebimentoDeContribuicaoInicial: string;
  recebimentoDeContribuicaoFinal: string;
  stAgendaRegulatoria: string;
};

export function filtrosPadrao(): ConsultarEventosFiltrosStorage {
  return {
    busca: "",
    numeroAudiencia: "",
    codigoAno: "",
    codigoSituacao: "",
    codigoTipoEvento: "",
    ordering: "ano",
    recebimentoDeContribuicaoInicial: "",
    recebimentoDeContribuicaoFinal: "",
    stAgendaRegulatoria: ConsultarEventosConstants.AGENDA_AMBOS,
  };
}

export function lerFiltrosDoStorage(): ConsultarEventosFiltrosStorage | null {
  const raw = sessionStorage.getItem(ConsultarEventosConstants.STORAGE_KEY);
  if (!raw) {
    return null;
  }
  try {
    return { ...filtrosPadrao(), ...JSON.parse(raw) };
  } catch {
    return null;
  }
}

export function salvarCampoFiltro(chave: keyof ConsultarEventosFiltrosStorage, valor: any) {
  const atual = lerFiltrosDoStorage() || filtrosPadrao();
  atual[chave] = valor;
  sessionStorage.setItem(
    ConsultarEventosConstants.STORAGE_KEY,
    JSON.stringify(atual)
  );
}

export function removerFiltrosDoStorage() {
  sessionStorage.removeItem(ConsultarEventosConstants.STORAGE_KEY);
}

export function isoParaData(valor: string): Date | null {
  if (!valor) {
    return null;
  }
  const [ano, mes, dia] = valor.split("-").map(Number);
  if (!ano || !mes || !dia) {
    return null;
  }
  return new Date(ano, mes - 1, dia);
}

export function dataParaIso(valor: Date | string | null | undefined): string {
  if (!valor) {
    return "";
  }
  const data = valor instanceof Date ? valor : new Date(valor);
  if (Number.isNaN(data.getTime())) {
    return "";
  }
  const ano = data.getFullYear();
  const mes = String(data.getMonth() + 1).padStart(2, "0");
  const dia = String(data.getDate()).padStart(2, "0");
  return `${ano}-${mes}-${dia}`;
}
